import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IClient } from "../clientModel";

export const getAllClient = createAsyncThunk(
  "ClientLogo/FindAllClientLogo",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/FindAllClientLogo`,
        {
          ClientName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Client:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createClient = createAsyncThunk(
  "ClientLogo/InsertClientLogo",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/InsertClientLogo`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Client:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateClient = createAsyncThunk(
  "ClientLogo/UpdateClientLogo",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/UpdateClientLogo`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Client:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteClient = createAsyncThunk(
  "ClientLogo/DeleteClientLogo",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/DeleteClientLogo`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Client :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getClientByID = createAsyncThunk(
  "ClientLogo/FindByIDClientLogo",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/FindByIDClientLogo`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ClientName: result.ClientName,
        Logo: result.Logo,
        IsActive: result.IsActive ? 1 : 2,
      } as IClient;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Client :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveClient = createAsyncThunk(
  "ClientLogo/FindAllActiveClientLogo",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/ClientLogo/FindAllActiveClientLogo`
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Client:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveClient = createAsyncThunk(
  "ClientLogo/ActiveInActiveClientLogo",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/ActiveInActiveClientLogo`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Client :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const ClientImageUpload = createAsyncThunk(
  "ClientLogo/ClientLogoImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/ClientLogoImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Client Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
